import { type ReactElement } from 'react';
import { Box, Text } from '@citibox-panel/ui';

// What the permission this screen governs actually does to a building, in the couriers' vocabulary.
// It rides the COUNTER'S column rather than the page header: it explains what «activada» means, and
// the number it explains is directly below it.
//
// No heading of its own — it captions the card beneath it, and a heading here would land between the
// page title and the card's own, breaking the outline an AT user navigates by.
//
// TODO: i18n — copy en ES hasta Fase 1.
export function PermissionSummary(): ReactElement {
  return (
    // Capped at a measure the eye can track in one pass; the column is already narrow, so this only
    // bites on a wide viewport.
    <Box sx={{ maxWidth: '62ch', mb: 2 }}>
      <Text variant="body1">
        Activa o desactiva el permiso de los mensajeros de Amazon para abrir los portales de
        comunidad con dispositivos Access.
      </Text>
    </Box>
  );
}
